import Sentiment from "../../../../../../../shared/util/salary/Sentiment";
import type {
  JobDetailsPreference,
  JobDetailsSectionModel,
  SegmentPreference,
  SegmentPreferenceAttribute,
} from "./types";

export function jobDetailsSectionModelFromVJModel(
  viewjobModel: model.viewjob.ViewJobClientSideModel,
): JobDetailsSectionModel | undefined {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const jobDetailsSection =
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    viewjobModel.jobInfoWrapperModel?.jobInfoModel?.jobDescriptionSectionModel?.jobDetailsSection;
  if (jobDetailsSection != null) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return {
      ...jobDetailsSection,

      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access
      jobTypes: jobDetailsPreferenceFromVJModel(jobDetailsSection.jobTypes),

      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access
      segmentPreferences: segmentPreferenceFromVJModel(jobDetailsSection.segmentPreferences),

      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access
      shiftsAndSchedule: jobDetailsPreferenceFromVJModel(jobDetailsSection.shiftsAndSchedule),
    };
  }
}

// Instead of changing the enums to union types, I decided to use this mapping because changing the references
// would take too much effort.
export function jobDetailsPreferenceFromVJModel(
  preferences: component.jobdescriptionsection.JobDetailsPreference[] | undefined,
): JobDetailsPreference[] | undefined {
  return (
    preferences?.map((jobType) => {
      let sentiment: Sentiment;
      switch (jobType.sentiment) {
        case "NEGATIVE":
          sentiment = Sentiment.NEGATIVE;
          break;
        case "POSITIVE":
          sentiment = Sentiment.POSITIVE;
          break;
        default:
          sentiment = Sentiment.UNKNOWN;
      }
      return {
        ...jobType,
        sentiment,
      };
    }) ?? undefined
  );
}

export function segmentPreferenceFromVJModel(
  segmentPreferences: component.jobdescriptionsection.SegmentPreference[] | undefined,
): SegmentPreference[] | undefined {
  return segmentPreferences?.map((segmentPreference) => {
    const attributes: SegmentPreferenceAttribute[] = segmentPreference.attributes.map(
      (attribute) => {
        let sentiment: Sentiment;
        switch (attribute.sentiment) {
          case "NEGATIVE":
            sentiment = Sentiment.NEGATIVE;
            break;
          case "POSITIVE":
            sentiment = Sentiment.POSITIVE;
            break;
          default:
            sentiment = Sentiment.UNKNOWN;
        }
        return {
          ...attribute,
          sentiment,
        };
      },
    );
    return {
      ...segmentPreference,
      attributes,
    };
  });
}
